<a *ngIf="podsCount"
   class="br-link-1 text-ellipsis"
   (click)="onClick()">
  {{podsCount === 1 ? ('X_POD_IMAGE' | translate: {sum: podsCount}) : ('X_POD_IMAGES' | translate:   {sum: podsCount || 0}) }}
</a>
